import React, { useEffect, useState } from 'react';
import { NotificationData } from './NotificationData';
import { IshikawaDiagram } from './IshikawaDiagram';
import { LondonProtocol } from './LondonProtocol';
import { ActionPlan } from './ActionPlan';
import { AccountabilityMatrix } from './AccountabilityMatrix';
import { ArchivedStep } from './ArchivedStep';
import { FinishStep } from './FinishStep';
import Notifications from 'pages/Notifications';

interface NotificationsTreatmentsStepsProps {
  currentStepSelected: number;
  notificationSelectorIsLoading: boolean;
  resetField: any;
  dirtyFields: any;
  errors: any;
  authenticationSelector: any;
  tooltipAlert: any;
  watch: any;
  setValue: any;
  control: any;
  register: any;
  statusEdit: boolean;
  notificationById: any;
  setFileUploadS3Attached: any;
  setUrlUploadS3AttachedFile: any;
  setUrlDeleteS3AttachedFile: any;
  notificationStatusState: string;
  notificationStatus: any[];
  id: string;
  setDisclosure: any;
  disclosureFieldsAutoSave: any;
  disclosureError: any;
  managersReviewError: any;
  showDisclosure: boolean;
  loggedInUserIsResponsible: boolean;
}

const NotificationsTreatmentsSteps: React.FC<NotificationsTreatmentsStepsProps> = ({
  currentStepSelected,
  notificationSelectorIsLoading,
  resetField,
  dirtyFields,
  errors,
  authenticationSelector,
  tooltipAlert,
  watch,
  setValue,
  control,
  register,
  statusEdit,
  notificationById,
  setFileUploadS3Attached,
  setUrlUploadS3AttachedFile,
  setUrlDeleteS3AttachedFile,
  notificationStatusState,
  notificationStatus,
  id,
  setDisclosure,
  disclosureFieldsAutoSave,
  disclosureError,
  managersReviewError,
  showDisclosure,
  loggedInUserIsResponsible,
}) => {

  const [statusIsPendingFinishOrFinished, setStatusIsPendingFinishOrFinished] = useState(false)
  useEffect(() => {
    if (notificationStatusState) {
      const allowedPendingFinishOrFinished = [notificationStatus[4].label,notificationStatus[5].label]
      setStatusIsPendingFinishOrFinished(allowedPendingFinishOrFinished.includes(notificationStatusState))
    }
  }, [notificationStatusState])

  switch (currentStepSelected) {
    case 1:
      return (
        <>
          {!notificationSelectorIsLoading ? (
            <NotificationData
              resetField={resetField}
              dirtyFields={dirtyFields}
              errors={errors}
              auth={authenticationSelector}
              statusIsPendingFinishOrFinished={statusIsPendingFinishOrFinished}
              tooltipAlert={tooltipAlert}
              watch={watch}
              setValue={setValue}
              control={control}
              register={register}
              statusEdit={statusEdit}
              notification={notificationById}
              setFileUploadS3Attached={setFileUploadS3Attached}
              setUrlUploadS3AttachedFile={setUrlUploadS3AttachedFile}
              setUrlDeleteS3AttachedFile={setUrlDeleteS3AttachedFile}
              loggedInUserIsResponsible={loggedInUserIsResponsible}
              notificationStatusState={notificationStatusState}
            />
          ) : (
            <div data-testid="test-notification-treatment-step1-loader" className="min-h-[55vh]" />
          )}
        </>
      );
    case 2:
      return (
        <IshikawaDiagram
          notificationStatusState={notificationStatusState}
          currentUser={authenticationSelector?.dataJwt}
          notificationById={notificationById}
          statusIsPendingFinishOrFinished={statusIsPendingFinishOrFinished}
        />
      );
    case 3:
      return (
        <LondonProtocol
          statusIsArchivedOrFinished={statusIsPendingFinishOrFinished}
          notification={notificationById}
          tooltipAlert={tooltipAlert}
          currentUser={authenticationSelector?.dataJwt}
          notificationStatusState={notificationStatusState}
        />
      );
    case 4:
      return (
        <AccountabilityMatrix
          statusIsArchivedOrFinished={statusIsPendingFinishOrFinished}
          notification={notificationById}
          tooltipAlert={tooltipAlert}
          currentUser={authenticationSelector?.dataJwt}
          notificationStatusState={notificationStatusState}
        />
      );
    case 5:
      return (
        <ActionPlan
          id={id}
          currentUser={authenticationSelector?.dataJwt}
          tooltipAlert={tooltipAlert}
          notificationStatusState={notificationStatusState}
          notificationById={notificationById}
          statusIsArchivedOrFinished={statusIsPendingFinishOrFinished}
        />
      );
    case 6:
      return notificationStatusState === notificationStatus[5].label ? (
        <ArchivedStep tooltipAlert={tooltipAlert} />
      ) : (
        <FinishStep
          statusIsPendingFinishOrFinished={statusIsPendingFinishOrFinished}
          tooltipAlert={tooltipAlert}
          notification={notificationById}
          notificationStatusState={notificationStatusState}
          currentUser={authenticationSelector?.dataJwt}
          setDisclosure={setDisclosure}
          setDisclosureFieldsAutoSave={disclosureFieldsAutoSave}
          disclosureError={disclosureError}
          managersReviewError={managersReviewError}
          showDisclosure={showDisclosure}
        />
      );
    default:
      return <Notifications />;
  }
};

export default NotificationsTreatmentsSteps;
